import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface ChatMessage {
  id: string
  role: 'user' | 'assistant'
  content: string
  createdAt: number
}

// Keep the persisted history bounded
const MAX_STORED_MESSAGES = 50

interface ChatState {
  messages: ChatMessage[]
  isOpen: boolean
  isLoading: boolean
  error: string | null
  setOpen: (open: boolean) => void
  addMessage: (message: Omit<ChatMessage, 'id' | 'createdAt'>) => ChatMessage
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  clearChat: () => void
}

export const useChatStore = create<ChatState>()(
  persist(
    (set) => ({
      messages: [],
      isOpen: false,
      isLoading: false,
      error: null,

      setOpen: (open) => set({ isOpen: open }),

      addMessage: (message) => {
        const full: ChatMessage = {
          ...message,
          id: crypto.randomUUID(),
          createdAt: Date.now(),
        }
        set((state) => ({
          messages: [...state.messages, full].slice(-MAX_STORED_MESSAGES),
          error: null,
        }))
        return full
      },

      setLoading: (loading) => set({ isLoading: loading }),
      setError: (error) => set({ error }),
      clearChat: () => set({ messages: [], error: null }),
    }),
    {
      name: 'socios-chat-storage',
      partialize: (state) => ({ messages: state.messages }),
    }
  )
)
